'use client';

import React from 'react';
import SiteTermsOfServicesComponent from '@/components/tos/SiteTermsOfServicesComponent';

interface PageContentProps {
  locale: string;
}

export default function PageContent({ locale }: PageContentProps) {
  return <SiteTermsOfServicesComponent />;
}
